import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { ADD_SALES_REP_TO_BUDGET_ALLOCATION_API, RETRIVE_TENANT_ADD_ALLOCATION_DATA_API } from '../../api/api_data';
import { fail_retrieve_add_budget_allocation_data, loading_retrieve_add_budget_allocation_data, reset_retrieve_add_budget_allocation_data, success_retrieve_add_budget_allocation_data } from '../../reducers/auth_tenant/retrieve_add_budget_allocation_data_Slice';
import { ADD_TENANT_BUDGET_ALLOCATION_ERROR_MSG, ADD_TENANT_BUDGET_ALLOCATION_SUCCESS_MSG, COULD_NOT_RETRIEVE_DATA_ERROR_MSG, COULD_NOT_RETRIEVE_DATA_SUCCESS_MSG } from '../../utils/error_success_messages';
import * as app_consts from "../../utils/app_consts";
import { tenant_auth_actions_helper } from '../../actions/actions_helper';
import { useSelector } from 'react-redux';
import { messageToast } from '../../utils/Utils';
import { Alert, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import { Button, Col, Icon, Row, RSelect } from '../Component';
import TextInput from '../../pages/components/inputs/TextInput';
import { fail_add_tenant_budget_allocation, loading_add_tenant_budget_allocation, reset_add_tenant_budget_allocation, success_add_tenant_budget_allocation } from '../../reducers/auth_tenant/add_tenant_budget_allocation_Slice';

const initialState = { sales_rep_id: "", value: "" };

const AddSalesRepToBudgetAllocationModal = ({ tenant_info, user_info, isOpen, successFunction, closeModal }) => {

 const [open, setOpen] = useState(isOpen);
 const [loading, setLoading] = useState(false);
 const dispatch = useDispatch();
 const navigate = useNavigate();
 const [error, setError] = useState("");
 const [formData, setFormData] = useState(initialState);
 const { id } = useParams();
 const [sales_reps, setSalesReps] = useState([]);
 const [add_loading, setAddLoading] = useState(false);
 const [add_error, setAddError] = useState("");

 useEffect(() => {
  setOpen(isOpen);
  setFormData(initialState);
  if (isOpen)
  {
   retrieve_add_allocation_data();
  }
 }, [isOpen]);

 const retrieve_add_allocation_data = () => {
  setError("");
  dispatch(tenant_auth_actions_helper(loading_retrieve_add_budget_allocation_data, success_retrieve_add_budget_allocation_data, fail_retrieve_add_budget_allocation_data, COULD_NOT_RETRIEVE_DATA_ERROR_MSG, COULD_NOT_RETRIEVE_DATA_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIVE_TENANT_ADD_ALLOCATION_DATA_API}/${id}`));
 };

 // Listener
 const retrieve_add_budget_allocation_data_listener = useSelector((state) => state.retrieve_add_budget_allocation_data.retrieve_add_budget_allocation_data);

 useEffect(() => {
  if (retrieve_add_budget_allocation_data_listener.status !== app_consts.IDLE)
  {
   if (retrieve_add_budget_allocation_data_listener.status === app_consts.LOADING)
   {
    setLoading(true);
    setError("");
   } else
   {
    setLoading(false);
    if (retrieve_add_budget_allocation_data_listener.status === app_consts.FAIL)
    {
     setError(retrieve_add_budget_allocation_data_listener.message);
     messageToast(retrieve_add_budget_allocation_data_listener.message, app_consts.FAIL);
    } else if (retrieve_add_budget_allocation_data_listener.status === app_consts.SUCCESS)
    {
     const remapped_data = retrieve_add_budget_allocation_data_listener.data?.map((data) => { return { label: data?.name, value: data?.id }; });
     setSalesReps(remapped_data);
    }
    dispatch(reset_retrieve_add_budget_allocation_data());
   }
  }
 }, [retrieve_add_budget_allocation_data_listener]);

 const getSelectedOption = (value, options) => {
  return options?.find(option => option.value === value) || null;
 };

 // Handle Change Function
 const handleChange = (e) => {
  setFormData({ ...formData, [e.target.name]: e.target.value });
 };

 const handle_add_allocation = () => {
  setAddError("");
  const req_data = { ...formData, id: id };

  dispatch(tenant_auth_actions_helper(loading_add_tenant_budget_allocation, success_add_tenant_budget_allocation, fail_add_tenant_budget_allocation, ADD_TENANT_BUDGET_ALLOCATION_ERROR_MSG, ADD_TENANT_BUDGET_ALLOCATION_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${ADD_SALES_REP_TO_BUDGET_ALLOCATION_API}`, req_data));;
 };

 // Listener
 const add_tenant_budget_allocation_listener = useSelector((state) => state.add_tenant_budget_allocation.add_tenant_budget_allocation);

 useEffect(() => {
  if (add_tenant_budget_allocation_listener.status !== app_consts.IDLE)
  {
   if (add_tenant_budget_allocation_listener.status === app_consts.LOADING)
   {
    setAddLoading(true);
    setAddError("");
   } else
   {
    setAddLoading(false);
    if (add_tenant_budget_allocation_listener.status === app_consts.FAIL)
    {
     setAddError(add_tenant_budget_allocation_listener.message);
     messageToast(add_tenant_budget_allocation_listener.message, app_consts.FAIL);
    } else if (add_tenant_budget_allocation_listener.status === app_consts.SUCCESS)
    {
     closeModal();
     successFunction();
    }
    dispatch(reset_add_tenant_budget_allocation());
   }
  }
 }, [add_tenant_budget_allocation_listener]);

 return (
  <>
   <Modal isOpen={open} toggle={closeModal} className="modal-dialog-centered" size={"md"}>
    <ModalHeader toggle={closeModal}>Add Allocation</ModalHeader>
    <ModalBody>
     {
      loading ?
       <>
        <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
         <div className="text-soft fw-bold" style={{ fontSize: 24, marginTop: "90px" }}>Retrieveing Data...</div>
         <div className="nk-loader mt-2  w-70 m-auto "></div>
        </div>
       </>
       :
       <>
        {
         error ?
          <>
           <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
            <div className="text-soft fw-bold" style={{ fontSize: 24, marginTop: "90px" }}>{error}</div>
           </div>
          </>
          :
          <>
           <Row className="g-4">

            <Col size={12}>
             <div className="form-group">
              <label className="form-label mb-1 text-md" htmlFor="retrunable">
               Sales rep<span className='text-danger pr-2'>{` *`}</span>
              </label>
              <div className="w-100">
               <RSelect
                options={sales_reps}
                className="w-100"
                placeholder="Search"
                id="retrunable"
                onChange={(e) => {
                 setFormData({ ...formData, sales_rep_id: e.value });
                }}
                value={getSelectedOption(formData?.sales_rep_id, sales_reps)}
               />
              </div>
             </div>
            </Col>
            <TextInput
             label="Value (ZMW)"
             type="number"
             id_val="new_value"
             value={formData?.value}
             colSize="12"
             required
             name="value"
             handleChange={handleChange}
             onBlur={(e) => setFormData({ ...formData, value: parseFloat(e?.target?.value)?.toFixed(2) })}
            />
            {add_error && (
             <div className="my-3 w-100">
              <Alert color="danger" className="alert-icon">
               <Icon name="alert-circle" /> {add_error}{" "}
              </Alert>
             </div>
            )}
            <Col xl="12" className="d-flex justify-content-end mt-4 mr-2">
             <Button onClick={handle_add_allocation} disabled={
              (loading || add_loading) ||
              !(formData?.sales_rep_id && formData?.value)
             } color="primary">
              {loading || add_loading ? <Spinner size="sm" color="light" /> : "Add Allocation"}
             </Button>
            </Col>
           </Row>
          </>
        }
       </>
     }
    </ModalBody>
   </Modal>
  </>
 );
};

export default AddSalesRepToBudgetAllocationModal;